<script setup>
    import { ref, onMounted } from 'vue';
    import axios from 'axios';
    import * as bootstrap from 'bootstrap';

    const props = defineProps(['fetchUrl']);

    const firmennachzahler = ref({
        Firmennachzahler: '',
    });

    const submitResult = ref(null);
    const submitError = ref(null);
    onMounted(() => {
        // setup for component to add banking details for the consumer
        document.getElementById("rechnungsempfaenger").value = document.getElementById("rechnungsempfaenger_").value;
        document.getElementById("teilnehmer").value = document.getElementById("teilnehmer_").value;
    })
    // Loads a bootstrap modal & saving the new firmennachzahler.
    async function saveFirmennachzahler() {
        try {
            // Rechnungsempfaenger, Teilnehmer and Firmennachzahler values for request
            const requestData = {
                Rechnungsempfaenger: document.querySelector('#rechnungsempfaenger').value,
                Teilnehmer: document.querySelector('#teilnehmer').value,
                Firmennachzahler: firmennachzahler.value.Firmennachzahler,
            };
            const response1 = await axios.post(props.fetchUrl, requestData);
            submitResult.value = response1;

            // Close the second modal after a one-second delay
            setTimeout(() => {
                // Values for Firmennachzahler values in the new modal
                const firmennachzahlerValue = createNachzahler.querySelector('#firmennachzahler').value;
                const tnValue = createNachzahler.querySelector('#teilnehmer').value;
                const rnValue = createNachzahler.querySelector('#rechnungsempfaenger').value;
                // Hide Modal
                const currentModalNach = document.querySelector('#createNachzahler');
                const modalNach = bootstrap.Modal.getInstance(currentModalNach);
                modalNach.hide();

                // Set Rechnungsempfaenger,Teilnehmer und Firmennachzahlervalues in the new modal
                const additionalModalRech = document.querySelector('#createRechnungsempfaenger');
                additionalModalRech.querySelector('#rechnungsempfaengernummer').value = rnValue;
                additionalModalRech.querySelector('#firmennachzahler').value = firmennachzahlerValue;
                additionalModalRech.querySelector('#teilnehmernummer').value = tnValue;
                // Show the new modal for Rechnungsempfaenger
                const additionalModalInstanceRech = new bootstrap.Modal(additionalModalRech);
                additionalModalInstanceRech.show();
            }, 1000);
        } catch (error) {
            submitError.value = error;
        }
    }
</script>

<template>
    <form @submit.prevent="submit">
            <div class="col-sm-4 mb-2">
                <label for="rechnungsempfaenger">Rechnungsempfaenger</label>
                <input id="rechnungsempfaenger"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>
            <div class="col-sm-4 mb-2">
                <label for="teilnehmer">Teilnehmer</label>
                <input id="teilnehmer"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>
            <div class="col-sm-4 mb-2">
                <label for="firmennachzahler">Firmennachzahler (*)</label>
                <input id="firmennachzahler"
                    type="text"
                    v-model="firmennachzahler.Firmennachzahler"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Firmennachzahler !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Firmennachzahler !== 'undefined')" v-html="submitError.response.data.Firmennachzahler[0]"></div>
            </div>
        <p>Felder mit einem * sind Pflichtfelder.</p>
        <button type="submit" class="btn btn-primary" @click.prevent="saveFirmennachzahler()">Firmennachzahler hinzufügen</button>
    </form>
    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Firmennachzahler erfolgreich hinzugefügt.</span>
    </div>
</template>
